import Vue from "vue";

const state = {
    patientId: "",
    patient: []
};

const mutations = {
    setPid(state, pid) {
        state.patientId = pid;
    },
    setPatient(state, patient) {
        state.patient = patient
    }
};

const actions = {
    setPid: ({commit, dispatch}, pid) => {
        commit("setPid", pid);
    },
    setPatient: ({commit, dispatch}, patient) => {
        commit("setPatient", patient);
    }
};


export default {
    state,
    mutations,
    actions
};
